import { graphql } from '../graphql/generated';

export const SEND_REQUESTS_MUTATION = graphql(`
  mutation SendRequests($requestIds: [ID!]!, $generateLocally: Boolean!) {
    sendRequests(requestIds: $requestIds, generateLocally: $generateLocally) {
      id
      status
      orders {
        id
        aisExportedAt
        correlationId
        orderFiles {
          id
          fileName
          printedAt
          printable
          printRequired
          printBeforeSend
          printCopies
        }
        orderLabels {
          id
          printedAt
          specimenId
          testTubeId
          location
          specialPrinterRequired
        }
      }
      additionalData
    }
  }
`);
